import React, {Fragment, h} from "preact";
import {AppPage} from "../../../_common/components/app-page";
import {useHistory} from "react-router-dom";
import {CF, FR} from "../../../_common/layout";
import {t} from '../../../_i18n';
import {UploadFile} from "../../../_common/forms/components/components";
import ButtonSpinner from "../../../_common/components/buttons/buttonSpinner/buttonSpinner";
import Modal from "../../../_common/components/Modal";
import {useState} from "preact/hooks";
import {toastService} from "../../../_services/toast-service";
import {isImageFile, resizeImage} from "../../../_common/common";
import {MAX_IMAGE_PIXELS} from "../../../constants";
import {uploadGraceConvocationDocument} from "../../../_rx/enrollment/exams/actions";
import {Checkbox} from "../../../_common/forms/components/Checkbox/Checkbox";
import {useSelector} from "react-redux";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";

export default function ModalGraceConvocationRequest({visible, graceConvocationStatus, closeModal}) {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [checkedFAs, setCheckedFAs] = useState([])
    const studentId = useSelector(state => state.auth.loggedUser.id)
    const coursingAcademicPrograms = useSelector(state => state.status.student_meta.enrolled_academic_programs)
    const hasCatFormativeZoneExpedient = coursingAcademicPrograms?.find(ap => ap.formative_zone === 'CAT')
    const hasMadFormativeZoneExpedient = coursingAcademicPrograms?.find(ap => ap.formative_zone === 'MAD')

    const handleUploadFile = (event) => {
        let eventFile = event.target.files[0];
        let newFiles = [...files, eventFile]
        setFiles(newFiles);
    }

    const handleRemoveFile = (fileId) => {
        let newFiles = files.filter(f => f.id !== fileId);
        setFiles(newFiles);
    }

    const handleSubmitFile = async () => {
        setLoading(true)
        const newStatus = {...graceConvocationStatus}
        const resp = await uploadGraceConvocationDocument(studentId, files, checkedFAs.join());

        if (resp.data) {
            const newPending = graceConvocationStatus.pending.filter(fa => !checkedFAs.includes(fa.formative_action_id))
            const checkedPending = graceConvocationStatus.pending.filter(fa => checkedFAs.includes(fa.formative_action_id))

            const newRefused = graceConvocationStatus.refused.filter(fa => !checkedFAs.includes(fa.formative_action_id))
            const checkedRefused = graceConvocationStatus.refused.filter(fa => checkedFAs.includes(fa.formative_action_id))

            const newSent = [...graceConvocationStatus.sent, ...checkedPending, ...checkedRefused]

            newStatus.pending = newPending
            newStatus.refused = newRefused
            newStatus.sent = newSent

            toastService.showToast({message:t("Solicitud enviada correctamente"), type:'info'})
        }

        setLoading(false)
        setFiles([])
        setCheckedFAs([])
        closeModal(newStatus);
    }

    const handleChecked = (checkVal, fa) => {
        if (checkVal === true) {
            let newCheckedFAs = [...checkedFAs, fa.formative_action_id];
            setCheckedFAs(newCheckedFAs)
        } else {
            setCheckedFAs(checkedFAs.filter(id => id !== fa.formative_action_id))
        }
    }

    return (
        <Modal visible={visible} closeModal={closeModal} bodyClass='sm-m-top modal-evau'>
            <FR className={'modal-title-padding row-2-el p-all p-x2-left p-x2-right'}>
                <div className='col-80'>
                    <p className="t-left font-24 font-bold no-margin">{t('Solicitar convocatoria')}</p>
                </div>
                <div className={'t-right col-20'}>
                    <a onClick={closeModal} className="modal-close-jobs modal-link">
                        <i className="fal fa-times font-20"/>
                    </a>
                </div>
            </FR>
            <hr className="separator-xxs no-margin-top"/>
            <div className='modal-evau__body'>
                <AlertBox type='info' className='m-top sm-no-m-top'>
                    <span dangerouslySetInnerHTML={{__html: t('grace_convo_modal_reminder')}}/>
                </AlertBox>
                {/*<p dangerouslySetInnerHTML={{__html: t('grace_convo_modal_reminder')}} />*/}
                <ol>
                    <li>
                        <p class="m-top">{t('Descarga y rellena el documento de solicitud:')}</p>
                        { hasCatFormativeZoneExpedient &&
                            <p>{t('Para ciclos semestrales:')}<a
                                href='https://storage.googleapis.com/area-onliner/Formulario_convocatoria_Cataluna.pdf'
                                target='_blank'><strong class="t-underline font-heavy">{t('Documento solicitud convocatoria (semestral).pdf')}</strong></a>
                            </p>
                        }
                        { hasMadFormativeZoneExpedient &&
                            <p>{t('Para ciclos anuales:')} <a
                                href='https://storage.googleapis.com/area-onliner/Formulario_convocatoria_Madrid.pdf'
                                target='_blank'><strong class="t-underline font-heavy">{t("Documento solicitud convocatoria (anual).pdf")}</strong></a>
                            </p>
                        }
                    </li>
                    <li>
                        <p>{t('Sube el documento de solicitud rellenado y los documentos que acrediten el motivo de la solicitud')}</p>
                        {files && files.map(file =>
                            <Fragment>
                                <div className='m-x2-bottom d-flex flex-center-y'>
                                    <span className='m-r'>{file.name}</span>
                                    <i className="fal fa-times-circle icon-color-red cursor-pointer"
                                       onClick={handleRemoveFile}/>
                                </div>
                            </Fragment>
                        )
                        }
                        <div className='m-x2-top'>
                            <UploadFile classNameButton='btn btn-ghost m-top m-bottom t-upper'
                                        accept='application/pdf,.docx,.doc,.odt' onChange={handleUploadFile}>
                                {t('Subir archivo')}
                            </UploadFile>
                            <span className='m-top font-color-879CA1'>{t('grace_convo_doc_types')}</span>
                        </div>
                    </li>
                    <li>
                        <p>{t('Selecciona las asignaturas para las que solicitas convocatoria de gracia:')}</p>
                        {graceConvocationStatus?.pending?.map(fa => {
                            return (
                                <Checkbox
                                    labelIsClicked={true}
                                    value={checkedFAs.includes(fa.formative_action_id)}
                                    onChange={value => handleChecked(value, fa)}
                                    label={<span>{fa.formative_action_code}. <b>{fa.formative_action_title}</b></span>}
                                />
                            )
                        })}
                        {graceConvocationStatus?.refused?.map(fa => {
                            return (
                                <Checkbox
                                    labelIsClicked={true}
                                    value={checkedFAs.includes(fa.formative_action_id)}
                                    onChange={value => handleChecked(value, fa)}
                                    label={<span>{fa.formative_action_code}. <b>{fa.formative_action_title}</b></span>}
                                />
                            )
                        })}
                    </li>
                </ol>


            </div>
            <hr className="separator-xxs no-margin"/>
            <div className='modal-evau__footer'>
                <ButtonSpinner showSpinner={loading} disabled={files.length < 1 || checkedFAs.length < 1} onClick={handleSubmitFile}>
                    {t('ENVIAR DOCUMENTO')}
                </ButtonSpinner>
            </div>

        </Modal>
    )
}
